import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useStyles } from "./ActivitesSectionStyle";
import clsx from "clsx";

const Plumbing = () => {
  const classes = useStyles();

  return (
    <Box className={classes.PlumbingMainContainer} id="a-propos">
      <Box className={classes.PlumbingBg}>
        <div className={classes.PlumbingTextContainer}>
          <div data-aos="fade-right">
            <Typography className={classes.PlumbingMainHeading}>
              Nous transformons vos données{" "}
              <span className={classes.LastLine}>
                <span className={classes.EnSpan}>en</span>{" "}
                <span className={classes.performanceSpan}>
                  performance grâce
                </span>{" "}
                au BIM
              </span>
            </Typography>
          </div>

          {/* <Box className={classes.Divider}></Box>
          <Box className={classes.AboutWrapper}>
            <div data-aos="fade-left">
              <Typography className={classes.AboutPlumbing}>
                Chez SONABIM, nous adoptons une approche concrète et itérative,
                en phase avec les réalités terrain de nos clients INDUSTRIELS,
                FERROVIAIRES & MOBILITÉS :
              </Typography>

              <ul className={classes.AboutPlumbingList}>
                <li>
                  Nous intervenons dès la phase de numérisation pour garantir
                  une base fiable
                </li>
                <li>
                  Nous faisons évoluer la maquette vers un jumeau numérique
                  connecté
                </li>
                <li>
                  Nous développons des solutions simples, efficaces et orientées
                  résultats
                </li>
              </ul>

              <Typography className={classes.AboutPlumbing}>
                Ensemble, transformons vos projets en réussites durables !
              </Typography>
            </div>
          </Box> */}
        </div>
      </Box>
    </Box>
  );
};

export default Plumbing;
